'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default() {
        (0, _classCallCheck3.default)(this, _default);
        return (0, _possibleConstructorReturn3.default)(this, (_default.__proto__ || (0, _getPrototypeOf2.default)(_default)).apply(this, arguments));
    }

    (0, _createClass3.default)(_default, [{
        key: 'render',
        value: function render() {

            var width = this.props.width;
            var height = this.props.height;
            var color = this.props.color;
            var shapeRendering = this.props.shapeRendering || 'crispEdges';
            var thickness = this.props.thickness || 1;

            var path = '';

            for (var i = 0; i <= thickness / 2; ++i) {
                path += 'M' + i + ' 0 L' + width + ' ' + (height - i) + ' ';
                path += 'M' + (width - i) + ' 0 L0 ' + (height - i) + ' ';
            }

            for (var i = 1; i <= thickness / 2; ++i) {
                path += 'M0 ' + i + ' L' + (width - i) + ' ' + height + ' ';
                path += 'M' + width + ' ' + i + ' L' + i + ' ' + height + ' ';
            }

            var style = { stroke: color, strokeWidth: '1px' };

            return _react2.default.createElement(
                'svg',
                { width: width, height: height, style: { shapeRendering: shapeRendering } },
                _react2.default.createElement('path', { d: path, style: style })
            );
        }
    }]);
    return _default;
}(_react2.default.Component);

exports.default = _default;